export default "__VITE_ASSET__ClQWsMAr__"